const SKU_SELECTED = 'SKU_SELECTED';
const SELECTED_SKU_RESET = 'SELECTED_SKU_RESET';
const FREE_TRIAL_SELECTED = 'FREE_TRIAL_SELECTED';
const FREE_TRIAL_STARTED = 'FREE_TRIAL_STARTED';
const SUBSCRIPTION_SELECTED = 'SUBSCRIPTION_SELECTED';
const SUBSCRIPTION_STARTED = 'SUBSCRIPTION_STARTED';
const SUBSCRIPTION_REQUESTED = 'SUBSCRIPTION_REQUESTED';
const SKIP_FREE_TRIAL_SET = 'SKIP_FREE_TRIAL_SET';
const SKIP_FREE_TRIAL_RESET = 'SKIP_FREE_TRIAL_RESET';
const PRODUCTS_FETCHED = 'PRODUCTS_FETCHED';
const STORE_BENEFITS_FETCHED = 'STORE_BENEFITS_FETCHED';

export {
  SKU_SELECTED,
  SELECTED_SKU_RESET,
  FREE_TRIAL_SELECTED,
  FREE_TRIAL_STARTED,
  SUBSCRIPTION_SELECTED,
  SUBSCRIPTION_STARTED,
  SUBSCRIPTION_REQUESTED,
  SKIP_FREE_TRIAL_SET,
  SKIP_FREE_TRIAL_RESET,
  PRODUCTS_FETCHED,
  STORE_BENEFITS_FETCHED,
};
